import Bowser from 'bowser'

export default function validarBrowser (browser) {
  const userAgent = window.navigator.userAgent;
  const parser = Bowser.getParser(userAgent);
  const browserName = parser.getBrowser().name;

  return new RegExp(browser, 'i').test(browserName);
}